import * as React from "react";
import "./ColorSelectOption.component.css";
import { components } from "react-select";
import { useEffect, useRef } from "react";
export function ColorSelectOption(props) {
    const { value, label } = props.data;
    const colorDiv = useRef(null);
    useEffect(() => {
        if (colorDiv.current) {
            colorDiv.current.style.backgroundColor = value;
        }
    }, [value]);
    return (React.createElement(components.Option, Object.assign({}, props),
        React.createElement("div", { className: "color-select-option-container" },
            React.createElement("span", { className: "color-select-option-text" }, label),
            React.createElement("div", { style: { flexGrow: "1" } }),
            React.createElement("div", { className: "color-select-option-color", ref: colorDiv }))));
}
